// Ressources d'habilitation du lot 3. Comme celles du lot 2 (`ressource2`), elles complètent la liste centrale
// `RESSOURCES` sans la modifier : `ressource3()` assure le typage tant que Fable n'a pas ajouté ces codes.

import type { Ressource } from '../constantes';

export const RESSOURCES_LOT3 = [
  'besoins',
  'ordres_transport',
  'suivi_transport',
  'receptions',
  'rapprochements',
  'ventes',
  'stations',
] as const;
export type RessourceLot3 = (typeof RESSOURCES_LOT3)[number];

export const LIBELLES_RESSOURCES_LOT3: Record<RessourceLot3, string> = {
  besoins: 'Besoins, commandes et planification',
  ordres_transport: 'Ordres de transport et chargements',
  suivi_transport: 'Suivi géographique des transports',
  receptions: 'Réceptions des livraisons',
  rapprochements: 'Dossiers de rapprochement',
  ventes: 'Ventes journalières',
  stations: 'Exploitation des stations (horaires, incidents)',
};

export function ressource3(code: RessourceLot3): Ressource {
  return code as unknown as Ressource;
}
